export const REQUEST_GET_NOTIFICATIONS = 'REQUEST_GET_NOTIFICATIONS';
export const SUCCESS_GET_NOTIFICATIONS = 'SUCCESS_GET_NOTIFICATIONS';
export const FAILURE_GET_NOTIFICATIONS = 'FAILURE_GET_NOTIFICATIONS';
